<template>
  <v-list-item :disabled="inSchedule || hasConflict" :style="hasConflict ? 'font-style:italic;text-decoration:line-through' : ''" class="ml-2" @click="$emit('add')">
    <v-list-item-avatar v-if="entry.counts.rem === 0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="warning" v-on="on">fas fa-stop-circle</v-icon>
        </template>
        <span>Class is full.<br/>If you add this course you will be placed on the wait list.</span>
      </v-tooltip>
    </v-list-item-avatar>
    <v-list-item-avatar v-else-if="entry.counts.rem <= 5">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="info" v-on="on">fas fa-exclamation-circle</v-icon>
        </template>
        <span>Class is almost full; only {{ entry.counts.rem }} seats left.<br/>You may be placed on the wait list if you add this course.</span>
      </v-tooltip>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle>Section {{ entry.section }}</v-list-item-subtitle>
      <v-list-item-subtitle><span class="hidden-sm-and-down">Meets: </span><v-chip v-for="{ _id, days, startTime, endTime } in entry.meetingBase" :key="_id" class="mr-1" label outlined>{{ dayDisplay(days) }} {{ startTime }} - {{ endTime }}</v-chip></v-list-item-subtitle>
      <v-list-item-subtitle v-if="inSchedule">Already on your schedule</v-list-item-subtitle>
      <v-list-item-subtitle v-else-if="anotherSection">Another Section is on your schedule</v-list-item-subtitle>
      <v-list-item-subtitle v-else-if="hasConflict">Conflicts with another course on your schedule</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import { computed } from '@vue/composition-api'
import { hasOverlap } from './functions'

export default {
  props: {
    entry: {
      type: Object,
      required: true
    },
    schedule: {
      type: Array,
      required: true
    }
  },
  setup (props, { root }) {
    const inSchedule = computed(() => !!props.schedule.find(({ crn }) => crn === props.entry.crn))
    const anotherSection = computed(() => props.schedule.find(({ title }) => title.substr(0, title.indexOf(' ')) === props.entry.title.substr(0, props.entry.title.indexOf(' '))))
    const hasConflict = computed(() => {
      if (!('meetingBase' in props.entry)) return false
      for (const schedCourse of props.schedule) {
        if (!('meetingBase' in schedCourse) || schedCourse.crn === props.entry.crn) continue
        if (hasOverlap(props.entry, schedCourse)) return true
      }
      return false
    })

    function dayDisplay (days) {
      const hash = { M: 'Mon', T: 'Tue', W: 'Wed', R: 'Thu', F: 'Fri' }
      const arr = []
      for (let i = 0; i < days.length; i++) {
        arr.push(hash[days[i]])
      }
      return arr.join('/')
    }

    return {
      inSchedule,
      anotherSection,
      hasConflict,
      dayDisplay
    }
  }
}
</script>
